import React from 'react';
import UploadPage from '../components/Upload/UploadPage';
import '../components/Upload/UploadStyle.css';

function Upload() {
  return (
    <div>
      <UploadPage />
    </div>
  );
}

export default Upload;